module.exports = __webpack_public_path__ + "media/images/lb/409-3f31372e6b36a9c7324630b8eabb78d7.svg";